import './PrivacyPage.css';

function PrivacyPage() {
    return (
        <div className="text-left p-10 md:px-20 container mx-auto">
            <h1 className="pb-10 text-6xl">Privacy Policy</h1>

            <p>Hey there! Welcome to the privacy corner of self-affirmations.net. Here's a simple guide to how I handle your privacy:</p>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">What Data I Collect</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">No Personal Data:</span> I don't collect your name, email, or IP address. This site is totally static, which means nothing is processed on my server – everything happens on your own device (phone, tablet, computer, etc.).</li>
                <li><span className="font-bold">External Websites:</span> If you click on an ad or a link to another blog, those sites might collect your data. They have their own rules, so be sure to check out their Terms & Conditions and Privacy Policies.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">Cookies and Tracking</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">Consent Cookie:</span> A cookie named consent saves the date when you agree to these rules.</li>
                <li><span className="font-bold">Google Analytics Cookies:</span> I use cookies from Google Analytics to track website usage, like when most visitors are here and where they come from.</li>
                <ul>
                    <li>For more details, you can read about Google Analytics cookies <a href="https://support.google.com/analytics/answer/11593727?hl=en">here</a>.</li>
                </ul>
                <li><span className="font-bold">Ad Cookies:</span> When you click on an ad, it opens in a new tab and the website you visit may set its own cookies, which I have no control over.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">Why I Use Cookies and Tracking</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">Website Usage:</span> The Google Analytics data helps me see how the website is used so I can make it better for you.</li>
                <li><span className="font-bold">No Sharing:</span> I don't share any of your data with any third parties. Everything stays on your device.</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">Your Control and Rights</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">Keep Your Data:</span> Since almost everything is processed on your own device, you control it all!</li>
                <li><span className="font-bold">Deleting Cookies:</span> If you want to clear any data, just delete the cookies from your device. That's it!</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">Data Security</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">Simple and Safe:</span> Because I don't process data on my server, there's no big data store to worry about. Just keep your device secure!</li>
            </ul>

            <h2 className="pt-10 pb-3 font-bold text-4xl">
                <span className="colored-underline">Regulations</span>
            </h2>
            
            <ul>
                <li><span className="font-bold">Limited Impact:</span> Since I don't collect personal data, many of the strict data laws (like GDPR or CCPA) don't really apply here. But if you click on external links, check their policies for more details.</li>
            </ul>

            <br></br>
            <p>Thanks for reading, and enjoy using self-affirmations.net knowing that your privacy is respected!</p>

        </div>
    );
}

export default PrivacyPage;
